if(typeof window.addEventListener !== 'undefined'){
    window.addEventListener('load', function() {
        FastClick.attach(document.body);
    }, false);
}else{
    window.attachEvent('load', function() {
        FastClick.attach(document.body);
    });
}

jQuery(document).ready(function ($) {
    //moved to app.ready.js
	// var resizeTimer;

	$('.mailto').each(function(index, value){
		$(value).attr('href', 'mailto:' + $(value).attr('data-name') + '@' + $(value).attr('data-domain'));
	});

	// required ["helpMe", "detectMe", "dispatchMe"]
	var breakpoints = [SETTINGS.BREAKPOINTS.MD_MIN, SETTINGS.BREAKPOINTS.CUSTOMMENU_MIN, SETTINGS.BREAKPOINTS.LG_MIN, SETTINGS.BREAKPOINTS.XL_MIN]; // Use SETTINGS VALUES
	var breakpointHandler = function() {
		if(!Me.detect.isOldIE()) {
			var breakpoint;
			var viewPortSize = Me.help.dimension.getTotalW();

			if (viewPortSize < breakpoints[0]) {
				breakpoint = String(breakpoints[0] - 1) + "-";
			}

			for (var i in breakpoints) {
				if (breakpoints[Number(i) + 1] != undefined && viewPortSize >= breakpoints[i] && viewPortSize < breakpoints[Number(i) + 1]) {
					breakpoint = String(breakpoints[i]) + "-" + String(breakpoints[Number(i) + 1] - 1);
				}
				if (viewPortSize >= breakpoints[breakpoints.length - 1]) {
					breakpoint = String(breakpoints[i]) + "+";
				}
			}

			if (SETTINGS.BREAKPOINT != breakpoint) {
				SETTINGS.BREAKPOINT = breakpoint;
				Me.dispatch.emit('breakpointChanged', this, {breakpoint: breakpoint});
			}
		}
	};
	$(window).resize(breakpointHandler);

	// required ["helpMe", "detectMe", "dispatchMe"]
	var deviceHandler = function(){
		if(!Me.detect.isOldIE()) {
			var device;
			var viewPortSize = Me.help.dimension.getTotalW();
			if (viewPortSize < 768) {
				device = "mobile";
			} else if (viewPortSize >= 768 && viewPortSize <= 1024) {
				device = "tablet";
			} else {
				device = "computer";
			}

			if(SETTINGS.DEVICE != device) {
				if(device == "mobile" && !SETTINGS.IS_MOBILE) {
					SETTINGS.IS_MOBILE = true;
					Me.dispatch.emit('mobileChanged', this, {mobile: SETTINGS.IS_MOBILE});
				} else if (device != "mobile" && SETTINGS.IS_MOBILE) {
					SETTINGS.IS_MOBILE = false;
					Me.dispatch.emit('mobileChanged', this, {mobile: SETTINGS.IS_MOBILE});
				}
				SETTINGS.DEVICE = device;
				Me.dispatch.emit('deviceChanged', this, {device: device});
			}
		}
	};
	$(window).resize(deviceHandler);

	createRevealableElementWaypoint();

	function createRevealableElementWaypoint(){
		// Code for elements revealable on scroll
		// How to:
		// - add .has-revealable on the element that contains revealable element: transitions will trigger when this element is reached by half is height
		// - add .is-revealable on elements that need to reveal on scroll
		// - if you need to delay some transition, add those on the element itself
		$('.has-revealable').each(function (index) {
			var $element = $(this);

			if(!$element.hasClass('.is-revealed')){
				var $revealables = $element.find('.is-revealable');

				if ($revealables.length == 0) {
					return false;
				}

				new Waypoint({
					element: $element,
					handler: function (direction) {
						if (direction == 'down') {
							$element.addClass('is-revealed');
							$revealables.addClass('is-revealed');
							Me.dispatch.emit('Waypoint.animate', this, {target: $element});
						}
					},
					offset: $(window).height() * 0.5
				});
			}
		});
	}

	$('#changeBranch').on('change',function(){
		$(this).parent('form').submit();
	});

	$(window).resize();

	// $(window).on('scroll', function () {
	// 	if($(window).scrollTop() > 50 && !Cookies.get('newsletter-pizzadelight-onscroll')){
	// 		Me.dispatch.emit('modal-trigger', this, {name: 'newsletter-popup-onscroll', fixedMobile: true});
	// 	}
	// });



	//moved to app.ready.js
	// window.onload = function() {
	// 	console.log('onload');
	// 	var $ = jQuery;
    //
	// 	$( window ).resize(function() {
	// 		console.log(2);
	// 		window.isResizing = true;
    //
	// 		resizeTimer = setTimeout(function() {
	// 			console.log(3);
	// 			Me.dispatch.emit('resize', this);
	// 			window.isResizing = false;
	// 		}, 250);
	// 	});
	// 	Me.dispatch.emit('WindowLoaded', this);
	// 	window.dispatchEvent(new Event('resize'));
	// 	window.dispatchEvent(new Event('scroll'));
	// };

	// window.onload();
});
